import { render, staticRenderFns } from "./UserChatContainer.vue?vue&type=template&id=13e7b6a1&scoped=true&"
import script from "./UserChatContainer.vue?vue&type=script&lang=js&"
export * from "./UserChatContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserChatContainer.vue?vue&type=style&index=0&id=13e7b6a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e7b6a1",
  null
  
)

export default component.exports